import React from "react";

import { Link, LinkProps } from "react-router-dom";

import {
  MenuItemImplProps,
  MenuLink as ReachMenuLink,
} from "@reach/menu-button";

type MenuLinkProps = Pick<
  MenuItemImplProps,
  "children" | "disabled" | "index" | "valueText"
> & {
  onSelect?(): void;
} & {
  component?: any;
} & React.PropsWithoutRef<LinkProps>;

const MenuLink: React.FC<MenuLinkProps> = ({ children, ...props }) => {
  return <ReachMenuLink as={Link} {...props}>{children}</ReachMenuLink>;
};

export default React.memo(MenuLink);
